import React, { useState } from "react";
import Layout from "../../Layout/Layout";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Form } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useDispatch } from "react-redux";
import { ImgEmpty, isEmpty } from "../../actions/commonFunction";
import { addcategory } from "../../actions/users";
import { toast } from "react-toastify";

const initialFormValue = {
  name: "",
};

const CategoryAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formValue, setFormValue] = useState(initialFormValue);
  const [image, SetImage] = useState({});
  const [validateError, setValidateError] = useState({});
  const [number, setNumber] = useState([0]);
  const [subcategory, setSubCategory] = useState({});

  const onChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } };
    setValidateError({});
    setFormValue(formData);
  };

  const { name } = formValue;

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let errors = Validate();

    if (isEmpty(errors)) {
      var arr = [];
      number.map((val) => {
        arr.push(subcategory[val]);
      });
      let reqData = {
        name,
        image: image,
      };
      reqData.subcategory = JSON.stringify(arr);

      const { error } = await addcategory(reqData);

      if (isEmpty(error)) {
        toast.success("Category details added", 1000);
        setTimeout(() => navigate("/categorylist"), 1000);
      } else {
        setValidateError(error);
      }
    } else {
      setValidateError(errors);
    }
  };

  const FileChange = (e) => {
    var file = e.target.files[0];
    var fileName = file.name;
    var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
    var validExtensions = ["png", "webp", "PNG", "jpg", "JPEG", "jpeg", "JPG"]; //array of valid extensions
    if (validExtensions.findIndex((check) => check == fileNameExt) === -1) {
      toast.error("Only these file types are accepted : " + validExtensions);
      return false;
    }
    SetImage(file);
  };

  var onsubChange = (e) => {
    setValidateError({});
    const { id, value } = e.target;

    setSubCategory({ ...subcategory, ...{ [id]: value } });
  };

  var Validate = () => {
    var error = {};
    if (isEmpty(name)) {
      error.name = "Category Name Required";
    }
    number.map((val) => {
      if (isEmpty(subcategory[val])) {
        error["subcategor" + val] = "Sub-Category Required";
      }
    });
    return error;
  };

  const deleteSubCategory = (ind) => {
    let data = subcategory;
    delete data[ind];
    Object.values(data).map((val, ind) => {
      data[ind] = val;
    });
    setSubCategory({ ...data });
    let num = number;
    num.splice(num.indexOf(ind), 1);
    setNumber([...num]);
  };

  return (
    <Layout>
      <div className="categoryadd">
        <Link to="/categorylist" className="btn sitebtn mb-4">
          Back
        </Link>
        <h1 className="pagehead">Add Category</h1>
        <div className="cardbox">
          <Form>
            <Row>
              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group className="d-flex align-items-end gap-4">
                  <div className="flex-grow-1">
                    <Form.Label>Category name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Category name"
                      onChange={onChange}
                      id="name"
                      value={name}
                    />
                    {validateError.name && (
                      <span className="text-danger">{validateError.name}</span>
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn sitebtn py-2 px-3"
                    onClick={() => {
                      setNumber([...number, ...[number.length]]);
                    }}
                  >
                    Add
                  </button>
                </Form.Group>

                {number?.length > 0 ? (
                  number?.map((val, ind) => {
                    return (
                      <>
                        <Col xs={12} sm={12} md={6} className="mb-3">
                          <Form.Group className="d-flex align-items-end gap-4">
                            <div className="flex-grow-1">
                              <Form.Label>Sub-Category name</Form.Label>
                              <Form.Control
                                type="text"
                                onChange={onsubChange}
                                id={String(ind)}
                                value={subcategory[ind] || ""}
                              />
                            </div>
                            <button
                              type="button"
                              className="btn sitebtn py-2 px-3"
                              onClick={() => {
                                deleteSubCategory(ind);
                              }}
                            >
                              Delete
                            </button>
                          </Form.Group>
                        </Col>
                        {validateError["subcategor" + ind] && (
                          <span className="text-danger">
                            {validateError["subcategor" + ind]}
                          </span>
                        )}
                      </>
                    );
                  })
                ) : (
                  <></>
                )}
              </Col>
              {/* {
                                number?.length > 0
                                    ?
                                    (number?.map((val, ind) => {
                                        return (
                                            <>
                                                <Col xs={12} sm={12} md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Sub-Category name</Form.Label>
                                                        <Form.Control type="text" onChange={onsubChange} id={String(ind)} value={subcategory[ind] || ''} />
                                                    </Form.Group>
                                                    {
                                                        validateError['subcategor' + ind] && <span className="text-danger">{validateError['subcategor' + ind]}</span>
                                                    }
                                                </Col>
                                            </>
                                        )
                                    }
                                    ))
                                    :
                                    <></>
                            } */}


              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    Choose Profile :{" "}
                    <small className="t-grey pl-3">
                      JPG, JPEG, PNG, WEBP. Max 30 megabytes
                    </small>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    id="image"
                    onChange={(e) => FileChange(e)}
                  />
                </Form.Group>
              </Col>

              {/* <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Profile Preview</Form.Label>
                                    <div className="uploadimgbox">
                                        <img
                                            src={
                                                ImgEmpty(image)
                                                ?    
                                                noimage
                                                :
                                                (
                                                    URL.createObjectURL(image)
                                                )
                                            } 
                                            alt="" 
                                            className="img-fluid previewimg"
                                            
                                        />
                                    </div>
                                </Form.Group>
                            </Col> */}
            </Row>
            <button
              type="button"
              className="btn sitebtn py-2 px-3"
              onClick={handleFormSubmit}
            >
              Add
            </button>
          </Form>
        </div>
      </div>
    </Layout>
  );
};

export default CategoryAdd;

